if (!customElements.get('featured-blog-picker')) {
  customElements.define(
    'featured-blog-picker',
    class FeaturedBlogPicker extends HTMLElement {
      connectedCallback() {
        this.sliderWrapper = this.querySelector('.featured-blog__items');
        this.enableSwiper = this.dataset.enableSwiper === 'true';
        this.items = parseInt(this.dataset.items) || 3;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 2;
        this.mobileItems = parseInt(this.dataset.mobileItems) || 1;
        this.sliderInstance = false;

        if (!this.enableSwiper || !this.sliderWrapper) return;
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 16;

        const sliderOptions = {
          slidesPerView: this.mobileItems,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          loop: false,
          threshold: 2,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId !== this.dataset.sectionId) return;
            const index = Number(e.target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }
  );
}
